import { render } from "./AdminMedia.vue?vue&type=template&id=2b9ed108&scoped=true"
import script from "./AdminMedia.vue?vue&type=script&lang=js"
export * from "./AdminMedia.vue?vue&type=script&lang=js"

import "./AdminMedia.vue?vue&type=style&index=0&id=2b9ed108&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9ed108"]])

export default __exports__